const te = {
  nav: {
    login: 'లాగిన్',
    bookNow: 'ఇప్పుడే బుక్ చేయండి',
    dashboard: 'డాష్‌బోర్డ్',
    back: 'వెనుకకు',
    home: 'హోమ్',
  },
  landing: {
    heroTitle1: 'ఆకాశ ప్రయాణాలు,',
    heroTitle2: 'ఇప్పుడు సులభం',
    heroSubtitle: 'భారతదేశపు ప్రముఖ హెలికాప్టర్ చార్టర్ అగ్రిగేటర్. ధృవీకరించబడిన ఆపరేటర్లతో కనెక్ట్ అవ్వండి, తక్షణమే విమానాలను బుక్ చేయండి.',
    bookYourFlight: 'మీ విమానాన్ని బుక్ చేయండి',
    becomeOperator: 'ఆపరేటర్ అవ్వండి',
    whyChoose: 'AirYatra ఎందుకు?',
    verifiedOperators: 'ధృవీకరించబడిన ఆపరేటర్లు',
    verifiedOperatorsDesc: 'అన్ని ఆపరేటర్లు AOC సర్టిఫికెట్లు, బీమా మరియు భద్రతా సమ్మతితో పూర్తిగా ధృవీకరించబడ్డారు.',
    bestPrices: 'ఉత్తమ ధరలు',
    bestPricesDesc: 'AI-ఆధారిత ధర సూచనలు బహుళ ఆపరేటర్ల నుండి పోటీ కొటేషన్లను అందిస్తాయి.',
    seamlessBooking: 'సులభ బుకింగ్',
    seamlessBookingDesc: 'కొటేషన్ అభ్యర్థనల నుండి డిజిటల్ టికెట్ల వరకు, మీ మొత్తం ప్రయాణాన్ని ఒకే ప్లాట్‌ఫారమ్‌లో నిర్వహించండి.',
    flightsCompleted: 'పూర్తయిన విమానాలు',
    verifiedOperatorsStat: 'ధృవీకరించబడిన ఆపరేటర్లు',
    safetyRecord: 'భద్రతా రికార్డు',
    customerRating: 'కస్టమర్ రేటింగ్',
    premiumServices: 'ప్రీమియం సేవలు',
    elevateExperience: 'మీ అనుభవాన్ని పెంచుకోండి',
    premiumSubtitle: 'మా ప్రీమియం సభ్యత్వం మరియు కార్పొరేట్ ప్రయాణ పరిష్కారాలతో ప్రత్యేక ప్రయోజనాలను పొందండి',
    blackDesc: '20% వరకు తగ్గింపు, ప్రాధాన్యత బుకింగ్, ప్రత్యేక పైలట్ మరియు లాంజ్ యాక్సెస్‌తో ప్రీమియం సభ్యత్వం.',
    priorityQueue: 'ప్రాధాన్యత బుకింగ్ క్యూ',
    dedicatedManager: 'ప్రత్యేక రిలేషన్‌షిప్ మేనేజర్',
    freeCancellation: 'ఉచిత రద్దు',
    exploreMembership: 'సభ్యత్వం చూడండి',
    corporateConsole: 'కార్పొరేట్ కన్సోల్',
    corporateDesc: 'ఆమోద వర్క్‌ఫ్లోలు, బడ్జెట్లు మరియు ఏకీకృత బిల్లింగ్‌తో సంస్థల కోసం కేంద్రీకృత ప్రయాణ నిర్వహణ.',
    employeeManagement: 'ఉద్యోగుల నిర్వహణ',
    budgetControls: 'బడ్జెట్ నియంత్రణలు',
    travelAnalytics: 'ప్రయాణ విశ్లేషణ',
    corporateRegistration: 'కార్పొరేట్ నమోదు',
    documentVault: 'డాక్యుమెంట్ వాల్ట్',
    vaultDesc: 'DGCA పత్రాలు, బీమా, లైసెన్సుల కోసం సురక్షిత ఎన్‌క్రిప్టెడ్ నిల్వ - గడువు హెచ్చరికలు మరియు వెర్షన్ నియంత్రణతో.',
    encryption: 'AES-256 ఎన్‌క్రిప్షన్',
    expiryReminders: 'గడువు రిమైండర్లు',
    secureSharing: 'సురక్షిత భాగస్వామ్యం',
    openVault: 'వాల్ట్ తెరవండి',
    loginToAccess: 'యాక్సెస్ కోసం లాగిన్ చేయండి',
    readyTakeOff: 'టేకాఫ్‌కు సిద్ధమా?',
    ctaSubtitle: 'ఈరోజే మీ హెలికాప్టర్ చార్టర్‌ను బుక్ చేసి విమానయాన శ్రేష్ఠతను అనుభవించండి.',
    startBooking: 'బుకింగ్ ప్రారంభించండి',
    footerText: '© 2025 AirYatra. అన్ని హక్కులు రక్షించబడ్డాయి. భారతదేశపు ప్రముఖ హెలికాప్టర్ చార్టర్ ప్లాట్‌ఫారమ్.',
  },
  booking: {
    title: 'మీ విమానాన్ని బుక్ చేయండి',
    subtitle: 'AirYatra - ప్రీమియం ఎయిర్ మొబిలిటీ సేవలు',
    previous: 'మునుపటి',
    next: 'తదుపరి',
    loginPrompt: 'బుకింగ్ విచారణ కోసం దయచేసి లాగిన్ చేయండి',
    loginBtn: 'లాగిన్',
    steps: {
      passengers: 'ప్రయాణికులు',
      booking_type: 'బుకింగ్ రకం',
      route: 'మార్గం',
      price_inquiry: 'ధర',
    },
  },
  bookingForm: {
    selectAircraftType: 'విమాన రకాన్ని ఎంచుకోండి',
    maxPassengers: 'గరిష్టంగా {{count}} ప్రయాణికులు',
    adultPassengers: 'వయోజన ప్రయాణికులు',
    male: 'పురుషులు',
    female: 'మహిళలు',
    totalAdults: 'మొత్తం వయోజనులు',
    children: 'పిల్లలు (4 సంవత్సరాల వరకు)',
    childrenFree: 'ఉచితం - గరిష్టంగా 2 పిల్లలు',
    flightType: 'విమాన రకం',
    selectOption: '-- ఎంచుకోండి --',
    bookingFor: 'ఎవరి కోసం బుకింగ్',
    bookingPurpose: 'బుకింగ్ ఉద్దేశ్యం',
    selected: 'ఎంచుకున్నది',
    specifyPurpose: 'ఉద్దేశ్యాన్ని తెలపండి',
    pickupLocation: 'పికప్ ప్రదేశం',
    selectPickupPoint: 'పికప్ పాయింట్ ఎంచుకోండి',
    dropLocation: 'డ్రాప్ ప్రదేశం',
    selectDropPoint: 'డ్రాప్ పాయింట్ ఎంచుకోండి',
    estimatedDistance: 'అంచనా దూరం',
    villageDocsTitle: 'గ్రామ ల్యాండింగ్ - పత్రాలు అవసరం',
    villageDocsDesc: 'గ్రామం/ప్రైవేట్ భూమిపై ల్యాండింగ్ కోసం, మీరు అధికారుల నుండి క్రింది పత్రాలు పొందాలి:',
    villageDocsNote: 'బుకింగ్ నిర్ధారణ తర్వాత, మీరు ఈ పత్రాలను అప్‌లోడ్ చేయాలి. Admin/Operator ధృవీకరించిన తర్వాతే పైలట్ ఎగురుతారు.',
    departureDate: 'బయలుదేరే తేదీ',
    pickupTime: 'పికప్ సమయం',
    additionalOptions: 'అదనపు ఎంపికలు (ఐచ్ఛికం)',
    waitingTime: 'నిరీక్షణ సమయం (నిమిషాలు)',
    waitingTimeNote: 'మొదటి 30 నిమిషాలు ఉచితం, తర్వాత ఛార్జీలు వర్తిస్తాయి',
    nightHalts: 'రాత్రి బస',
    nightHaltsNote: 'సిబ్బంది వసతి ఛార్జీలు కలిపి',
    bookingSummary: 'బుకింగ్ సారాంశం',
    aircraftTypeLabel: 'విమాన రకం:',
    totalPassengersLabel: 'మొత్తం ప్రయాణికులు:',
    adults: 'వయోజనులు',
    childrenLabel: 'పిల్లలు',
    flightTypeLabel: 'విమాన రకం:',
    pickupLabel: 'పికప్:',
    dropLabel: 'డ్రాప్:',
    distanceLabel: 'దూరం:',
    dateTimeLabel: 'తేదీ & సమయం:',
    at: 'కు',
    villageApprovalTitle: 'గ్రామ ల్యాండింగ్ - అడ్మిన్ ఆమోదం అవసరం',
    villageApprovalDesc: 'మీ విచారణ అడ్మిన్ ఆమోదం కోసం సమర్పించబడుతుంది. ఆమోదం తర్వాత చెల్లింపు ప్రారంభమవుతుంది.',
    priceBreakdown: 'ధర వివరాలు',
    baseFlightCost: 'ప్రాథమిక విమాన ఖర్చు',
    flightCost: 'విమాన ఖర్చు',
    positioningCost: 'పొజిషనింగ్ ఖర్చు (డెడ్-లెగ్)',
    roundTripDiscount: 'రౌండ్ ట్రిప్ తగ్గింపు',
    operatorGrossCost: 'ఆపరేటర్ స్థూల ఖర్చు',
    additionalCharges: 'అదనపు ఛార్జీలు',
    waitingGroundHolding: 'నిరీక్షణ / గ్రౌండ్ హోల్డింగ్',
    nightHalt: 'రాత్రి బస ({{count}} రాత్రులు)',
    crewAccommodation: 'సిబ్బంది వసతి & భోజనం',
    fuelSurcharge: 'ఇంధన సర్‌ఛార్జ్',
    platformFees: 'ప్లాట్‌ఫారమ్ ఫీజులు',
    convenienceFee: 'సౌకర్య రుసుము',
    insurance: 'బీమా',
    peakSurge: 'పీక్ సీజన్ సర్జ్',
    platformCommission: 'ప్లాట్‌ఫారమ్ కమిషన్',
    included: 'కలిపి ఉంది',
    helipadCharges: 'హెలిప్యాడ్ ల్యాండింగ్ ఛార్జీలు',
    totalLandingCharges: 'మొత్తం ల్యాండింగ్ ఛార్జీలు',
    taxableAmount: 'పన్ను విధించదగిన మొత్తం',
    totalGst: 'మొత్తం GST',
    grandTotal: 'మొత్తం మొత్తం',
    inclusiveTaxes: 'అన్ని పన్నులతో సహా',
    operatorReceives: 'ఆపరేటర్ అందుకుంటారు',
    specialRequirements: 'ప్రత్యేక అవసరాలు (ఐచ్ఛికం)',
    specialRequirementsPlaceholder: 'ఏవైనా ప్రత్యేక అభ్యర్థనలు లేదా అవసరాలు...',
    submitting: 'సమర్పిస్తోంది...',
    submitApproval: 'ఆమోదం కోసం సమర్పించండి',
    generateInquiry: 'విచారణ పంపండి',
    approvalNote: 'గ్రామ ల్యాండింగ్ కోసం అడ్మిన్ ఆమోదం అవసరం.',
    inquiryNote: 'విచారణ తర్వాత, ఆపరేటర్లు మీకు కొటేషన్లు పంపుతారు.',
    formRestored: 'ఫారమ్ డేటా పునరుద్ధరించబడింది!',
    selectAircraftError: 'దయచేసి విమాన రకాన్ని ఎంచుకోండి',
    minAdultError: 'కనీసం 1 వయోజన ప్రయాణికుడు అవసరం',
    maxChildrenError: 'గరిష్టంగా 2 పిల్లలు మాత్రమే',
    selectFlightTypeError: 'దయచేసి విమాన రకాన్ని ఎంచుకోండి',
    selectBookingForError: 'ఎవరి కోసం బుకింగ్ అనేది ఎంచుకోండి',
    selectPurposeError: 'బుకింగ్ ఉద్దేశ్యాన్ని ఎంచుకోండి',
    selectPickupError: 'పికప్ ప్రదేశాన్ని ఎంచుకోండి',
    selectDropError: 'డ్రాప్ ప్రదేశాన్ని ఎంచుకోండి',
    selectDateError: 'బయలుదేరే తేదీని ఎంచుకోండి',
    selectTimeError: 'పికప్ సమయాన్ని ఎంచుకోండి',
    priceWaitError: 'ధర లెక్కించబడలేదు! దయచేసి వేచి ఉండండి',
    inquirySubmitted: 'విచారణ సమర్పించబడింది! ఆపరేటర్లు త్వరలో స్పందిస్తారు',
    noteVillageApproval: 'గ్రామ ల్యాండింగ్‌కు అడ్మిన్ ఆమోదం అవసరం',
    notePriceEngine: 'ఏవియేషన్-గ్రేడ్ ప్రైసింగ్ ఇంజిన్ ద్వారా లెక్కించబడింది',
    noteFinalPrice: 'తుది ధరను ఆపరేటర్ నిర్ధారిస్తారు',
    docCollectorNoc: 'కలెక్టర్ NOC',
    docFireDept: 'అగ్నిమాపక శాఖ రసీదు',
    docPoliceStation: 'స్థానిక పోలీస్ స్టేషన్ రసీదు',
    docSpDcp: 'SP/DCP రసీదు',
  },
  options: {
    helicopter: 'హెలికాప్టర్',
    chartered_plane: 'చార్టర్డ్ విమానం',
    one_hour: '1 గంట విమానం',
    two_hour: '2 గంటల విమానం',
    half_day: 'అర్ధ రోజు',
    full_day: 'పూర్తి రోజు',
    multi_city: 'బహుళ నగరాలు',
    point_to_point: 'పాయింట్-టు-పాయింట్',
    self: 'నా కోసం',
    friend_family: 'స్నేహితులు & కుటుంబం',
    company: 'కంపెనీ / కార్పొరేట్',
    political: 'రాజకీయ / VIP',
    other: 'ఇతర',
    wedding: 'పెళ్లి',
    temple_yatra: 'దేవాలయ యాత్ర',
    company_tour: 'కార్పొరేట్ టూర్',
    election_tour: 'ఎన్నికల ప్రచారం',
    medical_emergency: 'వైద్య అత్యవసరం',
    film_shooting: 'సినిమా షూటింగ్',
    general_tour: 'సాధారణ పర్యటన',
    pilgrimage: 'తీర్థయాత్ర',
    business: 'వ్యాపార సమావేశం',
  },
};

export default te;
